(function () {
  function initUrgencyTimerElement() {
    if (window.customElements && window.customElements.get('custom-deliver-order')) return;

    class UrgencyTimer extends HTMLElement {
      constructor() {
        super();
        this.timerContainer = null;
        this.dateDisplay = null;
        this.interval = null;
      }

      connectedCallback() {
        if (this.closest('[data-ctr-daily-deals]')) return;

        this.timerContainer = this.querySelector('#urgency_timer');
        this.dateDisplay = this.querySelector('#dynamic_current_date');

        if (this.dateDisplay) {
          this.dateDisplay.textContent = this.formatDate(new Date());
        }

        this.init();
      }

      disconnectedCallback() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
      }

      init() {
        this.setNextResetTime();
        this.startTimer();
      }

      setNextResetTime() {
        var now = new Date();
        var storedReset = window.localStorage.getItem('urgency_timer_reset');
        var resetTime;

        if (storedReset && parseInt(storedReset, 10) > now.getTime()) {
          resetTime = new Date(parseInt(storedReset, 10));
        } else {
          resetTime = new Date();
          resetTime.setHours(24, 0, 0, 0);
          window.localStorage.setItem('urgency_timer_reset', String(resetTime.getTime()));
        }

        this.targetTime = resetTime.getTime();
      }

      startTimer() {
        this.updateTimer();

        this.interval = window.setInterval(
          function () {
            var currentTime = Date.now();
            var distance = this.targetTime - currentTime;

            if (distance <= 0) {
              window.clearInterval(this.interval);
              this.interval = null;
              window.localStorage.removeItem('urgency_timer_reset');
              this.setNextResetTime();

              if (this.dateDisplay) {
                this.dateDisplay.textContent = this.formatDate(new Date());
              }

              this.startTimer();
            } else {
              this.updateTimer();
            }
          }.bind(this),
          1000
        );
      }

      updateTimer() {
        var now = Date.now();
        var distance = this.targetTime - now;
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var displayHours = String(hours).padStart(2, '0');
        var displayMinutes = String(minutes).padStart(2, '0');
        var displaySeconds = String(seconds).padStart(2, '0');

        if (this.timerContainer) {
          this.timerContainer.innerHTML =
            '<div class="time-block"><span class="time-value">' +
            displayHours +
            '</span><span class="time-unit">HRS</span></div>' +
            '<div class="time-block"><span class="time-value">' +
            displayMinutes +
            '</span><span class="time-unit">MIN</span></div>' +
            '<div class="time-block"><span class="time-value">' +
            displaySeconds +
            '</span><span class="time-unit">SEC</span></div>';
        }
      }

      formatDate(date) {
        var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
        return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
      }
    }

    window.customElements.define('custom-deliver-order', UrgencyTimer);
  }

  function initDailyDeals(root) {
    if (!root || root.dataset.ctrDailyDealsInitialized === 'true') return;
    root.dataset.ctrDailyDealsInitialized = 'true';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-daily-deal-card]'));
    var buybox = root.querySelector('[data-daily-deals-buybox]');
    var checkoutButton = root.querySelector('[data-daily-deals-checkout]');
    var message = root.querySelector('[data-daily-deals-message]');
    var countdown = root.querySelector('[data-daily-deals-countdown]');
    var urgencyTimerContainer = root.querySelector('custom-deliver-order #urgency_timer');
    var urgencyDateDisplay = root.querySelector('custom-deliver-order #dynamic_current_date');
    var galleryWrap = root.querySelector('[data-daily-deals-gallery]');
    var galleryMain = root.querySelector('[data-daily-deals-buybox-image]');
    var galleryThumbs = root.querySelector('[data-daily-deals-thumbs]');
    var GALLERY_SIZES = '(min-width: 1200px) 630px, 100vw';
    var currentGalleryItem = null;

    setupFilters();

    if (!buybox || !checkoutButton || cards.length === 0) return;

    function isSubscriptionPriceDisplay() {
      return (root.getAttribute('data-price-display') || 'otp') === 'sub';
    }

    function isSubscriptionPurchaseAction() {
      return (checkoutButton.getAttribute('data-daily-deals-purchase-action') || 'otp') === 'sub';
    }

    function parseMoney(value) {
      var normalized = String(value || '').replace(/[^0-9.-]/g, '');
      var parsed = parseFloat(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function formatMoney(value) {
      return '$' + Number(value || 0).toFixed(2).replace(/\.00$/, '');
    }

    function getDealData(card) {
      var showSubPrices = isSubscriptionPriceDisplay();
      var useSubCheckout = isSubscriptionPurchaseAction();
      var regularPrice = card.getAttribute('data-regular-price') || '';
      var salePrice = card.getAttribute('data-sale-price') || '';
      var config = card.getAttribute('data-config') || '';

      if (showSubPrices) {
        regularPrice = card.getAttribute('data-subscription-price') || regularPrice;
        salePrice = card.getAttribute('data-subscription-sale-price') || salePrice;
      }

      if (useSubCheckout) {
        config = card.getAttribute('data-sub-config') || config;
      }

      var regular = parseMoney(regularPrice);
      var sale = parseMoney(salePrice);
      var savings = Math.max(regular - sale, 0);
      var discount = regular > 0 ? Math.round((savings / regular) * 100) : 0;

      return {
        title: card.getAttribute('data-title') || '',
        subtitle: card.getAttribute('data-subtitle') || '',
        config: config,
        image: card.getAttribute('data-image') || '',
        regularPrice: regularPrice,
        salePrice: salePrice,
        savings: savings,
        discount: discount
      };
    }

    function setText(selector, text) {
      var node = root.querySelector(selector);
      if (node) node.textContent = text;
    }

    function getStorageItem(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function setStorageItem(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        return;
      }
    }

    function randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function setupClaimedPercentages() {
      var storageKey = 'ctrDailyDealsClaimed:v1:' + window.location.pathname;
      var saved = {};

      try {
        saved = JSON.parse(getStorageItem(storageKey) || '{}') || {};
      } catch (error) {
        saved = {};
      }

      var used = Object.keys(saved).map(function (key) {
        return saved[key];
      });
      var available = [];

      for (var percent = 70; percent <= 96; percent += 1) {
        if (used.indexOf(percent) === -1) available.push(percent);
      }

      cards.forEach(function (card, index) {
        var key = card.getAttribute('data-claimed-key') || String(index);
        var claimed = parseInt(saved[key], 10);

        if (!Number.isFinite(claimed) || claimed < 70 || claimed > 96) {
          if (available.length > 0) {
            var availableIndex = randomInteger(0, available.length - 1);
            claimed = available.splice(availableIndex, 1)[0];
          } else {
            claimed = randomInteger(70, 96);
          }
          saved[key] = claimed;
        }

        var wrapper = card.querySelector('[data-daily-deals-claimed]');
        var fill = card.querySelector('[data-daily-deals-claimed-fill]');
        var text = card.querySelector('[data-daily-deals-claimed-text]');

        if (wrapper) wrapper.setAttribute('aria-label', claimed + ' percent claimed today');
        if (fill) fill.style.width = claimed + '%';
        if (text) text.textContent = claimed + '% Claimed';
      });

      setStorageItem(storageKey, JSON.stringify(saved));
    }

    function setupCountdown() {
      if (!countdown) return;

      var hoursNode = countdown.querySelector('[data-countdown-hours]');
      var minutesNode = countdown.querySelector('[data-countdown-minutes]');
      var secondsNode = countdown.querySelector('[data-countdown-seconds]');
      var sharedResetStorageKey = 'utb_reset';

      if (!hoursNode || !minutesNode || !secondsNode) return;

      function resolveSharedResetTime() {
        var now = Date.now();
        var storedReset = parseInt(getStorageItem(sharedResetStorageKey), 10);

        if (Number.isFinite(storedReset) && storedReset > now) {
          return storedReset;
        }

        var resetTime = new Date(now);
        resetTime.setHours(24, 0, 0, 0);
        var nextReset = resetTime.getTime();
        setStorageItem(sharedResetStorageKey, String(nextReset));
        return nextReset;
      }

      var endAt = resolveSharedResetTime();

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function formatDate(date) {
        var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
        return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
      }

      function renderUrgencyTimer(hours, minutes, seconds) {
        if (!urgencyTimerContainer) return;

        urgencyTimerContainer.innerHTML =
          '<div class="time-block"><span class="time-value">' +
          pad(hours) +
          '</span><span class="time-unit">HRS</span></div>' +
          '<div class="time-block"><span class="time-value">' +
          pad(minutes) +
          '</span><span class="time-unit">MIN</span></div>' +
          '<div class="time-block"><span class="time-value">' +
          pad(seconds) +
          '</span><span class="time-unit">SEC</span></div>';

        if (urgencyDateDisplay) {
          urgencyDateDisplay.textContent = formatDate(new Date());
        }
      }

      function renderCountdown() {
        var diff = endAt - Date.now();

        if (diff <= 0) {
          endAt = resolveSharedResetTime();
          diff = endAt - Date.now();
        }

        var hours = Math.floor(diff / 3600000) % 24;
        var minutes = Math.floor(diff / 60000) % 60;
        var seconds = Math.floor(diff / 1000) % 60;

        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(minutes);
        secondsNode.textContent = pad(seconds);
        renderUrgencyTimer(hours, minutes, seconds);
        countdown.setAttribute('aria-label', 'Daily deals countdown: ' + hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds');
      }

      renderCountdown();
      window.setInterval(renderCountdown, 1000);
    }

    function setupFilters() {
      var filters = root.querySelector('[data-daily-deals-filters]');
      if (!filters) return;

      var buttons = Array.prototype.slice.call(filters.querySelectorAll('[data-daily-deals-filter]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-daily-deals-group]'));

      function applyFilter(key) {
        buttons.forEach(function (button) {
          var isActive = (button.getAttribute('data-daily-deals-filter') || 'all') === key;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        groups.forEach(function (group) {
          group.hidden = key !== 'all' && group.getAttribute('data-daily-deals-group') !== key;
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          applyFilter(button.getAttribute('data-daily-deals-filter') || 'all');
        });
      });

      // Optional deep link: /pages/daily-deals#deals-summer
      var hashKey = (window.location.hash || '').replace(/^#deals-/, '');
      if (
        hashKey &&
        buttons.some(function (button) {
          return button.getAttribute('data-daily-deals-filter') === hashKey;
        })
      ) {
        applyFilter(hashKey);
      }
    }

    // ---- Buy box gallery ----

    function parseGallery(card) {
      var node = card.querySelector('[data-daily-deal-gallery]');
      if (!node) return [];

      try {
        var parsed = JSON.parse(node.textContent || '[]');
        return Array.isArray(parsed)
          ? parsed.filter(function (item) {
              return item && typeof item.src === 'string' && item.src.length > 0;
            })
          : [];
      } catch (error) {
        return [];
      }
    }

    function preloadGalleryItem(item) {
      if (!item) return null;
      if (item._loader) return item._loader;

      var loader = new Image();
      if (item.srcset) {
        loader.srcset = item.srcset;
        loader.sizes = GALLERY_SIZES;
      }
      loader.src = item.src;
      item._loader = loader;
      return loader;
    }

    function applyGalleryMain(item) {
      if (item.srcset) {
        galleryMain.setAttribute('srcset', item.srcset);
        galleryMain.setAttribute('sizes', GALLERY_SIZES);
      } else {
        galleryMain.removeAttribute('srcset');
        galleryMain.removeAttribute('sizes');
      }

      galleryMain.setAttribute('src', item.src);
      galleryMain.setAttribute('alt', item.alt || '');

      if (item.width && item.height) {
        galleryMain.setAttribute('width', item.width);
        galleryMain.setAttribute('height', item.height);
      }
    }

    function showGalleryImage(item, thumbButton) {
      if (!galleryMain || !item) return;

      if (galleryThumbs) {
        Array.prototype.forEach.call(galleryThumbs.querySelectorAll('[data-daily-deals-thumb]'), function (button) {
          button.setAttribute('aria-current', button === thumbButton ? 'true' : 'false');
        });
      }

      if (currentGalleryItem === item) return;
      currentGalleryItem = item;

      var loader = preloadGalleryItem(item);

      function applyFull() {
        if (currentGalleryItem !== item) return;
        applyGalleryMain(item);
      }

      if (loader && loader.complete && loader.naturalWidth) {
        applyFull();
        return;
      }

      if (item.thumb && galleryMain.getAttribute('src') !== item.src) {
        galleryMain.removeAttribute('srcset');
        galleryMain.removeAttribute('sizes');
        galleryMain.setAttribute('src', item.thumb);
        galleryMain.setAttribute('alt', item.alt || '');
      }

      if (!loader) {
        applyFull();
        return;
      }

      if (typeof loader.decode === 'function') {
        loader.decode().then(applyFull).catch(applyFull);
        return;
      }

      loader.addEventListener('load', applyFull);
      loader.addEventListener('error', applyFull);
    }

    function renderGallery(card, data) {
      currentGalleryItem = null;
      var items = parseGallery(card);

      if (items.length === 0 && data.image) {
        items = [{ src: data.image, alt: data.title }];
      }

      if (items.length === 0) return;

      var thumbsDisabled = !galleryThumbs || (galleryWrap && galleryWrap.hasAttribute('data-daily-deals-gallery-single'));

      if (thumbsDisabled || items.length < 2) {
        if (galleryThumbs) {
          galleryThumbs.innerHTML = '';
          galleryThumbs.hidden = true;
        }
        showGalleryImage(items[0], null);
        return;
      }

      galleryThumbs.innerHTML = '';
      var firstButton = null;

      items.forEach(function (item, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ctr-daily-deals__thumb';
        button.setAttribute('data-daily-deals-thumb', '');
        button.setAttribute('aria-label', 'View image ' + (index + 1) + ' of ' + items.length);
        button.setAttribute('aria-current', 'false');

        var img = document.createElement('img');
        img.src = item.thumb || item.src;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 160;
        img.height = 160;
        button.appendChild(img);

        function selectThumb() {
          showGalleryImage(item, button);
        }

        button.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          selectThumb();
        });
        button.addEventListener('click', selectThumb);

        galleryThumbs.appendChild(button);
        preloadGalleryItem(item);
        if (!firstButton) firstButton = button;
      });

      galleryThumbs.hidden = false;
      showGalleryImage(items[0], firstButton);
    }

    function applyOverride(target, override, defaultAttr) {
      if (!target) return;

      if (!target.hasAttribute(defaultAttr)) {
        target.setAttribute(defaultAttr, target.innerHTML);
      }

      target.innerHTML = override ? override.innerHTML : target.getAttribute(defaultAttr);
    }

    function applyBuyboxCopy(card) {
      // Per-deal body copy and lead line from the metaobject; section blocks are the fallback.
      applyOverride(
        root.querySelector('[data-daily-deals-buybox-copy]'),
        card.querySelector('[data-daily-deal-buybox-copy]'),
        'data-default-copy'
      );
      applyOverride(
        root.querySelector('[data-daily-deals-buybox-lead]'),
        card.querySelector('[data-daily-deal-buybox-lead]'),
        'data-default-copy'
      );

      // Pill text swaps for deals flagged Best seller.
      var pill = root.querySelector('[data-daily-deals-buybox-pill]');
      if (pill) {
        var isBestSeller = card.getAttribute('data-best-seller') === 'true';
        var html = isBestSeller ? pill.getAttribute('data-best-seller-html') : pill.getAttribute('data-default-html');
        var bg = pill.querySelector('.ctr-daily-deals__pill-bg-image');
        if (html !== null) {
          pill.innerHTML = html;
          if (bg) pill.insertBefore(bg, pill.firstChild);
        }
      }
    }

    function selectDeal(card, shouldScroll) {
      var data = getDealData(card);
      var subtitle = root.querySelector('[data-daily-deals-buybox-subtitle]');

      buybox.hidden = false;

      cards.forEach(function (item) {
        var isSelected = item === card;

        item.classList.toggle('is-selected', item === card);
        var button = item.querySelector('[data-daily-deals-select]');
        var label = item.querySelector('[data-daily-deals-select-label]');

        if (button) {
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        }

        if (button && label) {
          label.textContent = isSelected
            ? button.getAttribute('data-selected-label') || 'Selected Deal'
            : button.getAttribute('data-default-label') || 'Claim Deal Now';
        }
      });

      buybox.setAttribute('data-selected-config', data.config);
      setText('[data-daily-deals-buybox-title]', data.title);
      setText('[data-daily-deals-buybox-regular]', data.regularPrice);
      setText('[data-daily-deals-buybox-sale]', data.salePrice);
      setText('[data-daily-deals-buybox-discount]', data.discount + '% OFF TODAY');
      setText('[data-daily-deals-buybox-savings]', 'Total savings ' + formatMoney(data.savings));

      if (subtitle) {
        subtitle.textContent = data.subtitle;
        subtitle.hidden = !data.subtitle;
      }

      renderGallery(card, data);
      applyBuyboxCopy(card);

      if (message) message.textContent = '';

      if (shouldScroll) {
        buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function parseItems(config, options) {
      var value = String(config || '').trim();
      var seen = {};
      var withSellingPlan = options && options.withSellingPlan;

      if (!value) {
        return {
          items: [],
          error: 'This deal is missing checkout items. Please choose another deal.'
        };
      }

      var pairs = value.split(',');
      var items = [];

      for (var index = 0; index < pairs.length; index += 1) {
        var pair = pairs[index].trim();
        var parts = pair.split(':');

        if (parts.length < 2 || !/^\d+$/.test(parts[0]) || !/^\d+$/.test(parts[1])) {
          return {
            items: [],
            error: 'This deal has an invalid checkout setup. Please choose another deal.'
          };
        }

        var id = parseInt(parts[0], 10);
        var quantity = parseInt(parts[1], 10);
        var sellingPlan = withSellingPlan && parts.length >= 3 && /^\d+$/.test(parts[2]) ? parseInt(parts[2], 10) : null;

        if (!Number.isFinite(id) || id <= 0 || !Number.isFinite(quantity) || quantity <= 0) {
          return {
            items: [],
            error: 'This deal has an invalid checkout setup. Please choose another deal.'
          };
        }

        if (seen[id]) {
          seen[id].quantity += quantity;
        } else {
          seen[id] = {
            id: id,
            quantity: quantity
          };

          if (sellingPlan) {
            seen[id].selling_plan = sellingPlan;
          }

          items.push(seen[id]);
        }
      }

      return {
        items: items,
        error: ''
      };
    }

    function validateItems(items, withSellingPlan) {
      var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var variantBaseUrl = routeRoot.replace(/\/?$/, '/');

      return Promise.all(items.map(function (item) {
        return fetch(variantBaseUrl + 'variants/' + item.id + '.js', {
          method: 'GET',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('One item in this deal is no longer available. Please choose another deal.');
          }

          return response.json();
        }).then(function (variant) {
          if (variant.available === false) {
            throw new Error((variant.name || 'One item in this deal') + ' is currently sold out.');
          }

          if (
            variant.inventory_management &&
            variant.inventory_policy !== 'continue' &&
            Number.isFinite(variant.inventory_quantity) &&
            variant.inventory_quantity < item.quantity
          ) {
            throw new Error((variant.name || 'One item in this deal') + ' does not have enough inventory for this bundle.');
          }

          var validatedItem = {
            id: item.id,
            quantity: item.quantity,
            properties: { _daily_deal: 'true' }
          };

          if (withSellingPlan) {
            if (item.selling_plan) {
              validatedItem.selling_plan = item.selling_plan;
            } else if (
              variant.selling_plan_allocations &&
              variant.selling_plan_allocations.length > 0 &&
              variant.selling_plan_allocations[0].selling_plan_id
            ) {
              validatedItem.selling_plan = variant.selling_plan_allocations[0].selling_plan_id;
            } else {
              throw new Error((variant.name || 'One item in this deal') + ' is not available for subscription.');
            }
          }

          return validatedItem;
        });
      }));
    }

    cards.forEach(function (card) {
      var button = card.querySelector('[data-daily-deals-select]');

      if (button) {
        button.addEventListener('click', function () {
          selectDeal(card, true);
        });
      }

      // The whole card is clickable. The button keeps its own handler above, so
      // clicks that land on it (or on any other control) are left alone here.
      card.addEventListener('click', function (event) {
        if (event.defaultPrevented) return;
        if (event.target.closest && event.target.closest('a, button, input, select, textarea')) return;

        var selection = window.getSelection ? window.getSelection() : null;
        if (selection && selection.type === 'Range' && String(selection).length > 0) return;

        selectDeal(card, true);
      });
    });

    checkoutButton.addEventListener('click', function () {
      var config = buybox.getAttribute('data-selected-config') || '';
      var isSub = isSubscriptionPurchaseAction();
      var parsed = parseItems(config, { withSellingPlan: isSub });
      var items = parsed.items;
      var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
      var cartClearUrl = root.getAttribute('data-cart-clear-url') || '/cart/clear.js';
      var cartUpdateUrl = root.getAttribute('data-cart-update-url') || '/cart/update.js';

      if (parsed.error || items.length === 0) {
        if (message) message.textContent = parsed.error || 'This deal is missing checkout items. Please choose another deal.';
        return;
      }

      var idleLabel = checkoutButton.textContent;
      var loadingLabel = checkoutButton.getAttribute('data-loading-label') || '';

      checkoutButton.setAttribute('aria-disabled', 'true');
      checkoutButton.disabled = true;
      checkoutButton.classList.add('is-loading');
      if (loadingLabel) checkoutButton.textContent = loadingLabel;
      if (message) message.textContent = '';

      validateItems(items, isSub)
        .then(function (validatedItems) {
          // Only clear when there is something to clear; a GET is far cheaper than the POST.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .catch(function () { return { item_count: 1 }; })
            .then(function (cart) {
              if (!cart || cart.item_count === 0) return validatedItems;
              return fetch(cartClearUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
              }).then(function () {
                return validatedItems;
              });
            });
        })
        .then(function (validatedItems) {
          return fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: validatedItems })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw new Error(error.description || error.message || 'Unable to add this deal to cart.');
            });
          }

          // Backup attribution signal for order tagging; the line item property is
          // the primary signal, so a failure here must never block checkout.
          return fetch(cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { daily_deal: 'true' } })
          }).catch(function () {}).then(function () {
            // Skip-cart path: write the recurring-total attribute before navigating.
            return (window.RecurringBridge ? window.RecurringBridge.flush() : Promise.resolve())
              .then(function () { window.location.href = '/checkout'; });
          });
        })
        .catch(function (error) {
          if (message) message.textContent = error.message || 'Something went wrong. Please try again.';
        })
        .finally(function () {
          checkoutButton.removeAttribute('aria-disabled');
          checkoutButton.disabled = false;
          checkoutButton.classList.remove('is-loading');
          if (loadingLabel) checkoutButton.textContent = idleLabel;
        });
    });

    setupClaimedPercentages();
    setupCountdown();

    // Buy box opens with the default deal already selected (Best seller, else the first).
    var defaultHandle = buybox.getAttribute('data-default-deal') || '';
    var defaultCard = cards.filter(function (card) {
      return card.getAttribute('data-claimed-key') === defaultHandle;
    })[0] || cards[0];
    if (defaultCard) selectDeal(defaultCard, false);
  }

  function initAllDailyDeals() {
    initUrgencyTimerElement();
    var roots = document.querySelectorAll('[data-ctr-daily-deals]');
    roots.forEach(function (root) {
      initDailyDeals(root);
    });
  }

  initAllDailyDeals();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initUrgencyTimerElement();
    if (event.target.matches && event.target.matches('[data-ctr-daily-deals]')) {
      initDailyDeals(event.target);
      return;
    }
    var sectionRoot = event.target.querySelector ? event.target.querySelector('[data-ctr-daily-deals]') : null;
    if (sectionRoot) initDailyDeals(sectionRoot);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAllDailyDeals();
  });
})();
